import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

const HairLine = () => (
  <View style={styles.hairLine}>
    <HairLineDivider />
  </View>
);

const Content = (): React.ReactNode => {
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'whatIsVaStrings',
  });

  return (
    <View>
      <BodyBaseText numberOfLines={0} style={styles.title}>
        {translatedText('secondaryText')}
      </BodyBaseText>
      <ListItem
        primaryCopy={translatedText('advanceWithInMinutes')}
        showsChevron={false}
        leadingAccessory={{
          id: 'FLASH_ON_within_minutes',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'FLASH_ON',
          },
        }}
      />
      <HairLine />

      <ListItem
        primaryCopy={translatedText('noCreditScoreImpact')}
        showsChevron={false}
        leadingAccessory={{
          id: 'NO_CREDIT_SCORE_IMPACT',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'CREDIT_SCORE',
          },
        }}
      />
      <HairLine />

      <ListItem
        primaryCopy={translatedText('zeroInterest')}
        showsChevron={false}
        leadingAccessory={{
          id: 'SUN_zero_interest',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'SUN',
          },
        }}
      />
      <HairLine />

      <ListItem
        primaryCopy={translatedText('unlockLargeAmount')}
        showsChevron={false}
        leadingAccessory={{
          id: 'MONEY_BAG_direct_deposits',
          name: VXLComponentId.ICON_AVATAR,
          props: {
            iconKey: 'MONEY_BAG',
          },
        }}
      />
      <HairLineDivider />
    </View>
  );
};

const styles = StyleSheet.create({
  hairLine: {
    marginHorizontal: theme.spacing.m,
  },
  title: {
    backgroundColor: theme.color.background.primary,
    paddingHorizontal: theme.spacing.m,
    textAlign: 'center',
  },
});

export default Content;
